<template>
  <div class="uploading full-size flex-vertical">
    <ModalWindow
      ref="timerNotificationModalWindow"
      name="timerNotificationModalWindow"
      header="Предупреждение"
    >
      <div class="flex-vertical">
        <div class="timer-notification-modal-window-text">
          На загрузку всех документов отводится
          {{ expirationMinutes }} минут<br />
          (Таймер в верхнем правом углу)
        </div>
        <button @click="$refs.timerNotificationModalWindow.showed = false">
          Понятно
        </button>
      </div>
    </ModalWindow>
    <ModalWindow
      ref="invalidDocumentsModalWindow"
      name="invalidDocumentsModalWindow"
      header="Не все документы загружены"
    >
      <div class="flex-vertical" v-if="invalidDocuments.length > 0">
        <div class="invalid-documents-modal-window-text">
          <div v-if="invalidDocuments[0].isMissing">Отсутствует документ:</div>
          <div v-else>
            Загруженный документ не соответствует ожидаемому типу:
          </div>
          <br />
          — {{ invalidDocuments[0].title }}
        </div>
        <div class="invalid-document-buttons">
          <button @click="handleUploadInvalidDocumentClick">Загрузить</button>
          <button
            class="secondary-button"
            v-if="invalidDocuments[0].canSkip"
            @click="handleSkipInvalidDocumentClick"
          >
            Всё равно отправить
          </button>
          <button
            class="secondary-button"
            v-else
            @click="handleCancelSendingClick"
          >
            Отменить
          </button>
        </div>
      </div>
    </ModalWindow>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
    ></loading>
    <div class="uploading-header flex">
      <img class="header-logo" src="../../../public/icons/logo.svg" />
      <div class="header-title font-regular-13px">ЗАГРУЗКА ДОКУМЕНТОВ</div>
      <div class="header-empty-div"></div>
      <div v-show="showTimer" class="header-timer font-medium-11px">
        {{ timerMessage }}
      </div>
    </div>
    <div class="uploading-content full-size flex">
      <div class="uploading-documents full-height">
        <span class="documents-header font-semibold-18px"
          >Документы для загрузки</span
        >
        <div class="documents-list full-height flex-vertical">
          <div
            v-for="(document, index) in documentsData"
            :key="index"
            @click="selectedDocumentIndex = index"
            class="documents-list-item flex"
          >
            <div
              v-if="document.files.length === 0"
              class="document-index font-medium-16px"
            >
              {{ index + 1 }}
            </div>
            <div
              v-else-if="
                (document.type === 'WarTicket' &&
                  isLiableForMilitaryService === false) ||
                document.isValid === true
              "
              class="document-index"
            >
              <img src="../../../public/icons/success-32.svg" />
            </div>
            <div
              v-else-if="document.isValidating"
              class="document-index busy-loader"
            >
              <img src="../../../public/icons/busy-loader.svg" />
            </div>
            <div v-else class="document-index">
              <img src="../../../public/icons/error.svg" />
            </div>
            <div
              class="document-title font-regular-16px"
              :class="{ selected: selectedDocumentIndex === index }"
            >
              {{ document.title }}
            </div>
          </div>
        </div>
        <button @click="sendDocuments">Отправить документы</button>
      </div>
      <div class="uploaded-document full-heigth flex-vertical">
        <UploadingForm
          :title="currentDocumentData.title"
          :type="currentDocumentData.type"
          :files="currentDocumentData.files"
          ref="uploadingForm"
          @files-uploaded="handleFilesUploaded"
          @pdf-rendered="handlePdfRendered"
          @images-deleted="handleImagesDeleted"
          @uploading-started="startProcessingTimer"
          @select-next-step="selectNextStep"
        >
          <template slot="uploadingcomment" v-if="selectedDocumentIndex === 0">
            <div class="document-uploading-comment font-regular-16px">
              Загрузите 2 разворота:
              <ul class="passport-pages-list">
                <li>основной с фотографией</li>
                <li>актуальная прописка</li>
              </ul>
              Изображения должны быть высокого качества, без бликов. Страницы 
              паспорта полностью попадают в кадр и не закрыты пальцами.
            </div>
          </template>

          <template
            slot="uploadingcomment"
            v-if="
              selectedDocumentIndex === 1 &&
              currentDocumentData.files.length === 0
            "
          >
            <div class="document-uploading-comment font-regular-16px">
              Загрузите фотографию или скан только лицевой стороны документа.
            </div>
          </template>

          <template
            slot="uploadingcomment"
            v-if="
              selectedDocumentIndex === 2 &&
              currentDocumentData.files.length === 0
            "
            class="document-uploading-comment font-regular-16px"
          >
            <div class="document-uploading-comment font-regular-16px">
              Необязательный документ. При наличии – загрузите фотографию или
              скан только лицевой стороны документа.
            </div>
          </template>

          <div
            v-if="
              selectedDocumentIndex === 3 &&
              currentDocumentData.files.length === 0
            "
            class="military-document-content"
          >
            <div class="document-content-title font-semibold-18px">
              Являетесь ли вы военнообязанным(-ной)?
            </div>
            <div class="document-content-buttons flex">
              <BaseRadioButton
                v-model="currentDocumentData.isLiableForMilitaryService"
                :value="true"
                label="Являюсь"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.isLiableForMilitaryService"
                :value="false"
                label="Не являюсь"
              >
              </BaseRadioButton>
            </div>
          </div>
          <template slot="uploadingcomment" v-if="selectedDocumentIndex === 3">
            <div
              v-if="currentDocumentData.isLiableForMilitaryService"
              class="military-document-uploading-comment font-regular-16px"
            >
              Загрузите сканы военного билета или удостоверения гражданина,
              подлежащего призыву на военную службу, либо сканы документов, их
              заменяющие (временное удостоверение гражданина, справка).
            </div>
            <div v-else class="military-document-uploading-comment font-regular-16px">
              Загрузите скан страницы №13 паспорта с отметкой о воинской
              обязанности.
            </div>
          </template>

          <div
            v-if="selectedDocumentIndex === 4"
            class="education-document-content"
          >
            <div class="document-content-title font-semibold-18px">
              Уровень образования
            </div>
            <div class="document-content-buttons flex-vertical">
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="0"
                label="Высшее образование (диплом института/университета)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="1"
                label="Среднее профессиональное образование (диплом техникума/колледжа)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="2"
                label="Начальное профессиональное образование (диплом проф.училища/лицея)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="3"
                label="Среднее общее образование (аттестат выпускника 11-го класса)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
              <BaseRadioButton
                v-model="currentDocumentData.educationLevel"
                :value="4"
                label="Основное общее образование (аттестат выпускника 9-го класса)"
                @change="patchCurrentDocument"
              >
              </BaseRadioButton>
            </div>
          </div>
          <template slot="uploadingcomment" v-if="selectedDocumentIndex === 4">
            <div class="document-uploading-comment font-regular-16px">
              Загрузите, пожалуйста, только 1 документ, соответствующий уровню
              вашего образования.
            </div>
          </template>
        </UploadingForm>
      </div>
    </div>
  </div>
</template>

<script>
import UploadingPageMixin from "../mixins/UploadingPageMixin.js";
import BaseRadioButton from "../common/BaseRadioButton.vue";
import ModalWindow from "../common/ModalWindow.vue";
import UploadingForm from "./UploadingForm.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "UploadingPage",
  components: {
    UploadingForm,
    BaseRadioButton,
    ModalWindow,
    Loading,
  },
  mixins: [UploadingPageMixin],
};
</script>

<style lang="scss" scoped>
@import "../../../src/styles/colors.scss";

$uploading-documents-width: 29%;

.uploading {
  background-color: $background-color;
  padding: 25px 25px 25px;
}

.uploading-header {
  margin-bottom: 25px;
}

.header-title {
  margin-left: 13px;
  padding-left: 13px;
  border-left: 1px solid #1a1f2399;
  color: #1a1f2399;
}

.header-empty-div {
  flex: 1 0 0;
}

.header-timer {
  letter-spacing: 0.5px;
  color: #1a1f2399;
  border-radius: 4px;
  background-color: #959ba12f;
  padding: 2px 8px;
}

.uploading-content {
  max-height: calc(100% - 61px);
}

.uploading-documents {
  width: $uploading-documents-width;
  display: flex;
  flex-direction: column;
  background-color: $white-color;
  border-radius: 8px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  padding: 37px 23px 67px 25px;
  margin-right: 24px;
}

.documents-header {
  margin-bottom: 17px;
}

.documents-list {
  overflow-y: auto;
  margin-bottom: 5px;
}

.documents-list-item {
  border-bottom: 1px solid #1a1f2399;
  padding: 24px 11px 24px 0px;
  cursor: pointer;
}

.documents-list-item:hover {
  background-color: #f8f8f8;
}

.validation-message {
  color: red;
  font-family: IBMPlexSans-regular;
}

.document-index {
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  border-radius: 50%;
  background-color: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -5px;
}

.document-title {
  margin-left: 16px;
}
.document-title.selected {
  font-family: IBMPlexSans-semibold;
}

.uploaded-document {
  width: calc(100% - 24px - #{$uploading-documents-width});
  background-color: $white-color;
  border-radius: 8px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  padding: 50px 41px 50px 50px;
}

.document-content-title {
  margin-bottom: 10px;
}
.document-content-buttons {
  margin-bottom: 10px;
}

.document-content-buttons > div {
  margin-right: 12px;
  margin-bottom: 8px;
}

.military-document-uploading-comment,
.document-uploading-comment {
  margin-bottom: 22px;
  margin-right: 10px;
}

.timer-notification-modal-window-text {
  margin-bottom: 84px;
}
.timer-notification-modal-window-buttons {
  align-items: flex-start;

  button {
    margin-right: 8px;
  }
}

.invalid-documents-modal-window-text {
  margin-bottom: 84px;
}
.invalid-document-buttons {
  display: flex;
  align-self: center;
}
.invalid-document-buttons > button {
  margin-right: 12px;
}
.secondary-button {
  background: transparent;
  color: #181818;
  margin-right: 0px !important;
}
.passport-pages-list {
  list-style-position: inside; 
  margin: 10px 20px;
}

</style>